<template>
  <v-app>
    <v-main>
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      >
      <v-layout row>
        <v-flex xs9>
          <img
            src="../assets/rect51522.png"
            width="350"
            class="left"
          >
        </v-flex>
        <v-flex xs3>
          <v-btn
            title="Logout"
            text
            large
            icon
            color="teal"
            class="right mt-3"
            @click="dialogLogout()"
          >
            <v-icon title="Logout">
              logout
            </v-icon>
          </v-btn>
          <div class="font-weight-regular" />
        </v-flex>
      </v-layout>
      <v-divider />
      <v-layout
        column
        wrap
      >
        <v-layout>
          <!-- {{listaServicosEscolhidos}} -->
          <!-- disp:{{listaPacientesDisponiveis.length}} 
          penden: {{listaPacientesPendente.length}}-->
          <!-- dialogo para cadastrar consultas -->
          <v-layout
            row
            justify-center
          >
            <v-dialog
              v-model="dialoConsultasPaciente"
              persistent
              scrollable
              max-width="350px"
            >
              <v-card style="width: 400px ">
                <v-toolbar
                  color="primary"
                  dark
                >
                  <v-toolbar-title>Consultas realizadas</v-toolbar-title>
                  <v-spacer />

                  <v-btn icon>
                    <v-icon @click="fecharDialogConsultasPaciente">
                      close
                    </v-icon>
                  </v-btn>
                </v-toolbar>

                <v-divider />
                <v-window v-model="step">
                  <v-window-item
                    v-for="(item, index) in listaConsultasPacienteAgrupada"
                    :key="item.title"
                    :value="index"
                  >
                    <v-card-text style="height: 320px;">
                      <v-list
                        subheader
                        one-line
                      >
                        <v-subheader>{{ item[0].nomeUnidade }}</v-subheader>
                        <template v-for="(item, index) in item">
                          <v-list-item
                            :key="item.title"
                            :class="
                              item.status == 2 ? 'teal lighten-3': '' || item.tile == 1 ? 'teal lighten-3': '' "
                            ripple
                            :disabled="item.status == 2 || item.tile == 1 || item.idUnidade != user.idUnidade"
                          >
                            <v-list-item-action>
                              <v-checkbox v-model="item.status" />
                            </v-list-item-action>
                            <v-list-item-content @click="item.status = !item.status">
                              <v-list-item-title>
                                {{
                                  item.nomeExame
                                }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider
                            v-if="index + 1 < listaConsultasPaciente.length"
                            :key="index"
                          />
                        </template>
                      </v-list>
                    </v-card-text>
                  </v-window-item>
                </v-window>
                <v-card-actions class="pr-4">
                  <v-spacer />
                  <v-btn
                    rounded
                    color="primary"
                    dark
                    @click="encerrarAtendimento"
                  >
                    Finalizar Atendimento
                  </v-btn>
                  <v-spacer />
                  <v-icon
                    large
                    :disabled="step === 0"
                    @click="step--"
                  >
                    arrow_left
                  </v-icon>
                  <v-icon
                    large
                    :disabled="
                      step == listaConsultasPacienteAgrupada.length - 1
                    "
                    @click="step++"
                  >
                    arrow_right
                  </v-icon>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>

          <v-dialog
            v-model="dialogNaoExecutouExame"
            max-width="500"
          >
            <v-card>
              <v-card-title
                class="headline red lighten-1 white--text"
              >
                Você deve escolher um exame para finalizar o atendimento
              </v-card-title>

              <v-card-text>Realize um exame para continuar !!</v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="black darken-1"
                  text="text"
                  @click="dialogNaoExecutouExame = false"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogComformarSair"
            max-width="290"
          >
            <v-card>
              <v-card-title class="headline red lighten-1 white--text">
                Deseja realmente sair ?
              </v-card-title>

              <v-card-text>
                Você ainda possui pacientes com atendimento
                incompleto
              </v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="black darken-1"
                  text="text"
                  @click="dialogComformarSair = false"
                >
                  Voltar
                </v-btn>

                <v-btn
                  color="red darken-1"
                  text="text"
                  @click="logout"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogChamadaJaFeita"
            width="500"
          >
            <v-card>
              <v-card-title
                class="white--text headline red lighten-2 pl-4"
                primary-title
              >
                Paciente já chamado
              </v-card-title>

              <v-card-text>
                Essa Paciente já foi chamada por um outro Médico.
                <strong
                  class="red--text text--lighten-1"
                >Clique em Voltar,</strong>
                escolha outro paciente da lista para chamá-lo.
                <br>
              </v-card-text>

              <v-divider />

              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  @click="dialogChamadaJaFeita = false"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogProximoAtendimento"
            persistent
            max-width="490"
          >
            <v-card>
              <v-card-title class="white--text headline teal lighten-1">
                <v-flex row>
                  <p class="text-center">
                    {{ mensagemCabecalhoProximoAtendimento }}
                  </p>
                </v-flex>
              </v-card-title>
              <v-divider />
              <div v-if="possuiProximoAtendimento">
                <v-card-text
                  v-if="this.mensagemIdProximaUnidade != localEscolhido.idUnidade"
                  row
                  class="title"
                >
                  Unidade: {{ mensagemProximaUnidade }}
                </v-card-text>
                <v-divider />
                <v-card-text
                  v-if="consultas.length == 1"
                  class="pa-2 title"
                >
                  Serviço: {{ mensagemProximoServico }}
                </v-card-text>
                <v-card-text
                  v-if="consultas.length == 1"
                  class="pa-2 title"
                >
                  Exame: {{ mensagemProximoExame }}
                </v-card-text>

                <v-card-text                  
                  class="pa-2 title"
                >
                  Local: {{ mensagemProximoLocalDialog }}
                </v-card-text>                
                <!-- <v-divider></v-divider>          -->
              </div>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialogProximoAtendimento = false"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogNaoCompareceu"
            persistent
            max-width="490"
          >
            <template v-slot:activator="{on}" />
            <v-card>
              <v-card-title
                class="white--text headline red lighten-2"
              >
                Deseja enviar este Paciente para o Apoio?
              </v-card-title>
              <v-card-text>
                O Paciente será enviado para a lista de pacientes do Apoio, e
                poderá retornar a lista médica quando o mesmo
                desejar.
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialogNaoCompareceu = false"
                >
                  Não
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="chamadaNaoAtendida()"
                >
                  Sim
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <v-layout
          row
          justify-center
        >
          <v-dialog
            v-model="aguardandoConexao"
            persistent
            width="300"
          >
            <v-card
              color="primary"
              dark
            >
              <v-card-text>
                Aguardando conexão...
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <!-- tela inicial -->

        <v-layout
          v-if="!mostrarTelaPrincipal"
          justify-center
          row
          class="pa-5"
        >
          <v-flex
            xs12
            sm12
            md12
            lg8
          >
            <v-card class="rounded-card pl-4 pr-4">
              <br>
              <v-card-title
                primary-title
                class="teal--text pt-0 rounded-card-primeiraPagina justify-center"
              >
                <div>
                  <div class="mensagemInicial">
                    Olá, {{ nomeFormatado(user.nome) }}
                  </div>
                  <div class="mensagemInicial">
                    Escolha consultório ou
                    Laboratório e insira a identificação do mesmo.
                  </div>
                </div>
              </v-card-title>
              <v-divider class="mt-2" />

              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-autocomplete
                  v-model="unidadeSelecionada"
                  label="Unidade"
                  :items="listaUnidades"
                  item-value="idUnidade"
                  return-object
                  :rules="[v => !!v || 'Escolha a unidade de atendimento']"
                  item-text="nomeUnidade"
                  no-data-text="Nenhuma Unidade disponível"
                  required
                  @input="agruparLocaisPorUnidade(unidadeSelecionada)"
                />

                <v-autocomplete
                  v-model="localEscolhido"
                  label="Local de Atendimento"
                  :items="listaLocais"
                  return-object
                  item-value="idLocal"
                  :rules="[v => !!v || 'Local obrigatório']"
                  item-text="nomeLocal"
                  no-data-text="Nenhum Local disponível"
                  required
                  @input="agruparServicosPorLocal(localEscolhido)"
                />

                <v-autocomplete
                  v-model="listaServicosSelecionados"
                  label="Serviços"
                  :items="listaServicos"
                  item-value="idServico"
                  return-object
                  :rules="[v => v && v.length > 0 ||'Escolha os serviço da para seu atendimento']"
                  item-text="nomeEspecialidade"
                  no-data-text="Nenhum Serviço disponível"
                  required
                  multiple
                />

                <v-layout
                  wrap
                  align-center
                >
                  <v-flex
                    xs12
                    sm3
                  >
                    <v-select
                      v-model="descricaoLocal"
                      :items="itensDescricaoLocal"
                      item-text="descricao"
                      item-value="descricao"
                      label="Selecione o Local"
                      persistent-hint
                      return-object
                      single-line
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm9
                  >
                    <v-text-field
                      v-model="nomeConsultorio"
                      class="pl-3"
                      :rules="rules"
                      label="Número"
                    />
                  </v-flex>
                </v-layout>
                <br>
                <v-flex
                  xs12
                  sm12
                >
                  <template>
                    <div class="text-xs-center">
                      <v-btn
                        large
                        rounded
                        color="primary"
                        :disabled="!valid"
                        @click="adicionarServicosParaAtendimento()"
                      >
                        Iniciar Atendimentos
                      </v-btn>
                    </div>
                  </template>
                </v-flex>
              </v-form>
              <br>
            </v-card>
          </v-flex>
        </v-layout>

        <!-- tela Principal -->

        <v-layout
          v-if="mostrarTelaPrincipal"
          row
          class="pa-5 mr-1 ml-5"
        >
          <v-flex
            v-if="!isAtendimento && !isEspera"
            xs12
            sm5
            pa-2
          >
            <div
              v-if="
                listaPacientesPendente.length == 0 &&
                  listaPacientesDisponiveis.length == 0 &&
                  listaPacientesEspera.length == 0 &&
                  !isAtendimento &&
                  !fezChamada
              "
            >
              <v-alert
                class="rounded-card"
                :value="true"
                color="aBlue"
                type="info"
              >
                Aguardando Pacientes
              </v-alert>
            </div>

            <div v-else>
              <v-layout
                v-if="!ficha.codigo"
                class="pa-1 pl-4"
                wrap
                row
              >
                <v-flex
                  xs12
                  sm12
                  md12
                >
                  <v-card
                    v-if="!isPendentes && !exibirListaEspera"
                    class="rounded-card"
                    width="435px"
                    height="346px"
                  >
                    <v-toolbar
                      text
                      color="primary"
                      dark
                    >
                      <v-toolbar-title class="text-xs-center">
                        Pacientes Disponíveis
                      </v-toolbar-title>
                      <v-spacer />
                    </v-toolbar>
                    <v-list
                      :dense="true"
                      class="scroll-y"
                      style="max-height: 276px"
                      two-line
                    >
                      <template v-for="(item, index) in listaPacientesDisponiveis">
                        <v-list-item
                          :key="item.title"
                          :disabled="index > 100"
                          avatar
                          ripple
                          @click="toggle(index)"
                        >
                          <v-list-item-content @click="addFicha(item)">
                            <v-list-item-title>
                              <p class="text-sm-left font-weight-bold">
                                {{ item.nomePaciente }}
                              </p>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.nomeExame }} -
                              {{
                                item.nomeEspecialidade
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>	
                        </v-list-item>
                        <v-divider
                          v-if="index + 1 < listaPacientesDisponiveis.length"
                          :key="index"
                        />
                      </template>
                    </v-list>
                  </v-card>

                  <v-card
                    v-if="isPendentes && !exibirListaEspera"
                    class="rounded-card"
                    width="435px"
                    height="346px"
                  >
                    <v-toolbar
                      text
                      color="aBlue"
                      dark
                    >
                      <v-toolbar-title class="text-xs-center">
                        Pacientes Pendentes
                      </v-toolbar-title>
                      <v-spacer />
                    </v-toolbar>
                    <v-list
                      :dense="true"
                      class="scroll-y"
                      style="max-height: 276px"
                      two-line
                    >
                      <template v-for="(item, index) in listaPacientesPendente">
                        <v-list-item
                          :key="item.title"
                          avatar
                          ripple
                          @click="toggle(index)"
                        >
                          <v-list-item-content @click="addFicha(item)">
                            <v-list-item-title>
                              <p class="text-sm-left font-weight-bold">
                                {{ item.nomePaciente }}
                              </p>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.nomeExame }} -
                              {{
                                item.nomeEspecialidade
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider
                          v-if="index + 1 < listaPacientesPendente.length"
                          :key="index"
                        />
                      </template>
                    </v-list>
                  </v-card>

                  <v-card
                    v-if="exibirListaEspera"
                    class="rounded-card"
                    width="435px"
                    height="346px"
                  >
                    <v-toolbar
                      text
                      color="aBlue"
                      dark
                    >
                      <v-toolbar-title class="text-xs-center">
                        Pacientes em Espera
                      </v-toolbar-title>
                      <v-spacer />
                    </v-toolbar>
                    <v-list
                      :dense="true"
                      class="scroll-y"
                      style="max-height: 276px"
                      two-line
                    >
                      <template v-for="(item, index) in listaPacientesEspera">
                        <v-list-item
                          :key="item.title"
                          avatar
                          ripple
                          @click="toggle(index)"
                        >
                          <v-list-item-content @click="addFichaEspera(item)">
                            <v-list-item-title>
                              <p class="text-sm-left font-weight-bold">
                                {{ item.nomePaciente }}
                              </p>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ item.nomeExame }} - {{ item.nomeEspecialidade }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider
                          v-if="index + 1 < listaPacientesEspera.length"
                          :key="index"
                        />
                      </template>
                    </v-list>
                  </v-card>

                  <v-layout row>
                    <v-flex
                      sm6
                      xs12
                    >
                      <v-badge
                        v-if="
                          listaPacientesPendente.length > 0 ||
                            listaPacientesDisponiveis.length > 0 ||
                            listaPacientesEspera.length > 0
                        "
                        color="red"
                        overlap
                      >
                        <template
                          v-if="!isPendentes && !exibirListaEspera"
                          v-slot:badge
                        >
                          <span>{{ listaPacientesPendente.length }}</span>
                        </template>
                        <v-btn
                          v-if="
                            listaPacientesDisponiveis.length > 0 ||
                              listaPacientesPendente.length > 0 ||
                              listaPacientesEspera.length > 0
                          "
                          class="white--text"
                          rounded
                          :color="btnColor"
                          @click="changeColor"
                        >
                          <div v-if="!isPendentes">
                            Pacientes pendentes
                          </div>
                          <div v-if="isPendentes">
                            Pacientes disponiveis
                          </div>
                          <v-icon
                            right
                            dark
                          />
                        </v-btn>
                      </v-badge>
                    </v-flex>
                    <v-flex
                      sm4
                      xs12
                    >
                      <v-badge
                        v-show="ficha.nomePaciente == ''"
                        color="red"
                        overlap
                      >
                        <template v-slot:badge>
                          <span>{{ listaPacientesEspera.length }}</span>
                        </template>
                        <v-btn
                          depressed
                          rounded
                          color="#43A047"
                          class="white--text"
                          @click="exibirListaEspera = true"
                        >
                          pacientes em espera
                        </v-btn>
                      </v-badge>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <!-- parte esquerda -->

              <v-layout
                v-show="ficha.codigo"
                class="pa-2 pl-5"
                row
                wrap
              >
                <v-flex>
                  <v-card
                    width="335px"
                    color="primary"
                    dark
                    height="238px"
                  >
                    <v-card-text class="pa-0">
                      <h1>Chamadas Efetuadas</h1>
                    </v-card-text>
                    <v-card-text class="pa-0">
                      <p>
                        <font size="9.7">
                          <h1>{{ nChamada }}</h1>
                        </font>
                      </p>
                      <p>
                        <font>
                          <h2 class="text-truncate">
                            Aguarde o paciente...
                          </h2>
                        </font>
                      </p>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="text-center">
                        <v-spacer />
                        <v-btn
                          v-show="!fezChamada || emPacientePendente"
                          :disabled="isAtendimento"
                          light
                          class="white--text"
                          text
                          rounded
                          color="grey"
                          @click="voltar()"
                        >
                          <v-icon left>
                            keyboard_backspace
                          </v-icon>voltar
                        </v-btn>
                        <v-btn
                          :disabled="!ficha.nomeEspecialidade.length || desabilitaBotaoChamar"
                          class="white--text"
                          color="primary"
                          text
                          light
                          rounded
                          text
                          @click="fazerChamada()"
                        >
                          chamar
                          <v-icon right>
                            record_voice_over
                          </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>

          <!-- parte direita -->
          <v-flex xs12>
            <v-layout
              class="pa-2 pr-0"
              align-center
              column
              fill-height
            >
              <v-flex>
                <v-card
                  class="rounded-card"
                  width="535px"
                  :color="getColor(ficha.codigo)"
                  dark
                  min-height="366px"                  
                >
                  <div v-if="ficha.codigo !== ''">
                    <v-layout
                      row
                      class="align-center justify-center"
                    >
                      <div class="display-2">
                        {{ tempoAtendimento }}
                      </div>
                    </v-layout>

                    <v-card-title primary-title>
                      <v-img
                        src="https://cdn.pixabay.com/photo/2017/09/30/18/53/prognosis-icon-2803190_960_720.png"
                        height="125px"
                        contain
                      />
                    </v-card-title>
                    <v-card-text class="pb-0">
                      <h2 class="text-truncate">
                        Nome completo:
                        <br>
                        {{ ficha.nomePaciente }}
                      </h2>
                    </v-card-text>
                    <v-card-text class="pt-0">
                      <h2>
                        Exame(s):						           			
                        <br>	
                        <v-layout
                          row
                          justify-center
                          align-center
                        >					
                          {{ ficha.nomeExame }} <v-btn
                            v-show="ficha.atendimentos.length"
                            icon
                            small
                            @click="show = !show"
                          >
                            + {{ ficha.atendimentos.length }}
                          </v-btn> 
                        </v-layout> 						
                      </h2>

                      <v-expand-transition>
                        <div v-show="show">
                          <v-divider />					
                          <v-card-text>
                            <div
                              v-for="(atendimento, index) in ficha.atendimentos"
                              :key="index"
                            >
                              {{ atendimento.nomeExame }}
                              <v-divider
                                v-if="index + 1 < ficha.atendimentos.length"
                                :key="index"
                              />
                            </div>
                          </v-card-text>
                        </div>
                      </v-expand-transition>

                      <div justify-end>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <button
                              v-clipboard:copy="ficha.idOrdemServico"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onError"
                              type="button"
                              v-on="on"
                            >
                              Copiar O.S!
                            </button>
                          </template>
                          <span>{{ textClipBoard }}</span>
                        </v-tooltip>
                      </div>
                    </v-card-text>
                  </div>
                  <div
                    v-if="!ficha.codigo"
                    class="display-1"
                  >
                    Aguardando paciente...
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-layout row>
                  <v-btn
                    v-show="isEspera && !iniciouAtendimento"
                    depressed
                    class="white--text"
                    block
                    rounded
                    large
                    color="primary"
                    @click="reiniciarAtendimento()"
                  >
                    Continuar Atendimento
                    <v-icon
                      right
                      dark
                    />
                  </v-btn>

                  <v-btn
                    v-show="isEspera && !iniciouAtendimento"
                    large
                    outlinedd
                    class="rounded-card white--text"
                    color="compleLight"
                    @click="voltar()"
                  >
                    Voltar
                  </v-btn>
                  <v-btn
                    v-show="!iniciouAtendimento && !isEspera"
                    depressed
                    :disabled="!fezChamada"
                    class="white--text"
                    block
                    rounded
                    large
                    color="primary"
                    @click="iniciarAtendimento()"
                  >
                    Iniciar Atendimento
                    <v-icon
                      right
                      dark
                    />
                  </v-btn>

                  <v-btn
                    v-show="iniciouAtendimento"
                    depressed
                    class="white--text"
                    :disabled="!ficha.nomeEspecialidade"
                    block
                    rounded
                    large
                    color="primary"
                    @click="retornarConsultasPaciente()"
                  >
                    Encerrar Atendimento
                    <v-icon
                      right
                      dark
                    />
                  </v-btn>

                  <v-btn
                    v-if="!isAtendimento && !isEspera"
                    large
                    outlinedd
                    class="rounded-card white--text"
                    color="compleLight"
                    :disabled="!fezChamada || !habilitarBotaoCronometro || isAtendimento "
                    @click="dialogNaoCompareceu = true"
                  >
                    não compareceu {{ textCronometroRegrassivo }}
                  </v-btn>

                  <v-btn
                    v-if="isAtendimento"
                    large
                    depressed
                    outlinedd
                    class="rounded-card white--text"
                    color="tPurple"
                    @click="atendimentoEmEspera()"
                  >
                    Adicionar a lista de Espera
                  </v-btn>
                </v-layout>
              </v-flex>
              <br>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-main>
  </v-app>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import { mask } from "vue-the-mask";
import Typed from "typed.js";
import { getToken, setToken } from "../store/auth";
import medicoService from "../services/medico.service";
import socketService from "../services/socket.service";
import { Socket } from "dgram";
import { log } from "util";

export default {
  name: "HomeMedico",
  directives: {
    mask
  },
  data() {
    return {
      selected: [2],
	  mask: "#######",
	  items: [
      {
        id: 1,
        name: 'Applications :',
        children: [
          { id: 2, name: 'Calendar : app' },
          { id: 3, name: 'Chrome : app' },
          { id: 4, name: 'Webstorm : app' }
        ]
      },  
	],
	show: false,
      interval: "",
      emRefreshToken: false,
      textClipBoard: "Copiar O.S",
      step: 0,
      listaUnidades: [],
      unidadeSelecionada: "",
      varAguardandoConexao: 0,
      listaServicosDoMedico: [],
      listaServicos: [],
      listaLocais: [],
      valid: true,
      localEscolhido: "",
      nomeConsultorio: "",
	  possuiProximoAtendimento: false,
	  consultas:[],
      desabilitaBotaoChamar: false,
      drawer: null,
      fezChamada: false,
      emPacientePendente: false,
      emPacienteEspera: false,
      isAtendimento: false,
      user: "",
      radioProximoPaciente: "",
      btnColor: "aBlue",
      nChamada: 0,
      socket: "",
      socketAux: "",
      intervalos: [],
      habilitarBotaoCronometro: false,
      intervalContagemRegressiva: "",
      textCronometroRegrassivo: "[00:00]",
      minutesRegressivo: "",
      secondsRegressivo: "",
      tempoAtendimento: "00:00:00",
      seconds: 0 * 60,
      isPendentes: false,
      rulesConsultorioLaboratorio: [],
      isEspera: false,
      minutosAtendimento: "",
      botaoInicialDesabilitado: false,
      mensagemCabecalhoProximoAtendimento: "",
      mensagemProximoServico: "",
      mensagemProximoExame: "",
      mensagemProximaUnidade: "",
      mensagemIdProximaUnidade: "",
      mensagemProximoLocal: "",
	  mensagemProximoLocalMontada: "",
	  mensagemProximoLocalDialog:"",
      idLocalMedico: "",
      dialogChamadaJaFeita: false,
      dialogProximoAtendimento: false,
      dialogNaoExecutouExame: false,
      dialoConsultasPaciente: false,
      dialogComformarSair: false,
      listaPacientes: [],
      tamlistaPacientes: 0,
      listaPacientesDisponiveis: [],
      listaPacientesPendente: [],
      listaPacientesEspera: [],
      listaConsultasPaciente: [],
      listaConsultasPacienteAgrupada: [],
      dialogNaoCompareceu: false,
      nomePaciente: "",
      aguardandoConexao: false,
      contadorAguardandoConexao: 1,
      iniciouAtendimento: false,
      mensagemNotificacaoSocket: "default",
      ficha: {
        codigo: "",
        idServico: "",
        nomeEspecialidade: "",
        idAtendimento: "",
        idLocal: "",
        nomePaciente: "",
        status: "",
        idExame: "",
        prioridade: "",
        dataStatus: null,
        dataStatusCronometro: null,
        idLocalMedico: "",
        nomeExame: "",
        idOrdemServico: "",
		idConsulta: "",
		atendimentos:[]
		
      },
      exibirListaEspera: false,
      listaServicosDisponibilidade: [],
      mostrarTelaPrincipal: false,
      listaServicosSelecionados: "",
      listaServicosEscolhidos: [],
      dialog2: false,
      descricaoLocal: { descricao: "Consultório " },
      nomeConsultorioCompleto: "",
      itensDescricaoLocal: [
        { descricao: "Laboratório " },
        { descricao: "Consultório " }
      ]
    };
  },

  methods: {
    chamarCronometroRegressivo() {
      this.minutesRegressivo = 1;
      this.secondsRegressivo = this.minutesRegressivo * 60;
      this.intervalContagemRegressiva = setInterval(
        () => this.iniciarCronometroRegressivo(),
        1000
      );
    },

    iniciarCronometroRegressivo() {
      var min = Math.floor(this.secondsRegressivo / 60);
      var sec = this.secondsRegressivo - min * 60;
      sec === 0 ? (sec = "00") : "";
      sec > 0 && sec < 10 ? (sec = "0" + sec.toString()) : "";
      this.textCronometroRegrassivo = "[" + "0" + min.toString() + ":" + sec + "]";
      this.secondsRegressivo--;
      if (this.secondsRegressivo === -1) {
        this.textCronometroRegrassivo = "";
        this.secondsRegressivo--;
        this.habilitarBotaoCronometro = true;
        clearInterval(this.intervalContagemRegressiva);
      }
    },

    chamarCronometro() {
      var i1 = setInterval(() => this.iniciarCronometroAtendimento(), 1000);
      this.intervalos.push(i1);
    },

    iniciarCronometroAtendimento() {
      this.seconds += 1;
      const hours = Math.floor(this.seconds / 3600);
      const minutesLeft = Math.floor(this.seconds / 60) % 60;
      const secondsLeft = this.seconds % 60;
      this.tempoAtendimento =
        this.timeDurationToString(hours) +
        ":" +
        this.timeDurationToString(minutesLeft) +
        ":" +
        this.timeDurationToString(secondsLeft);
    },

    modificarListaPacientes() {
      console.log("aquiiiii");
      if (this.exibirListaEspera && this.isPendentes) {
        this.exibirListaEspera = false;
      } else if (this.exibirListaEspera && !this.isPendentes) {
        this.exibirListaEspera = false;
      } else if (!this.exibirListaEspera && this.isPendentes) {
        this.btnColor = "aBlue";
        this.isPendentes = !this.isPendentes;
      } else if (!this.exibirListaEspera && !this.isPendentes) {
        this.btnColor = "primary";
        this.isPendentes = !this.isPendentes;
      }
    },
    changeColor() {
      //this.isPendentes = !this.isPendentes;
      this.modificarListaPacientes();
      // this.btnColor = "aBlue";
      // if (this.isPendentes) {
      //   this.btnColor = "primary";
      // }
    },

    vertificarExameMedico(idServico, idExame) {
      var encontrou = false;
      if (this.listaServicosSelecionados[idServico] != null) {
        if (
          this.listaServicosSelecionados[idServico].examesIndexados[idExame] !=
          null
        ) {
          encontrou = true;
        }
      }
      if (encontrou) {
        return true;
      } else {
        return false;
      }
    },

    onCopy: function(e) {
      this.textClipBoard = "O.S copiada para a área de tranferência";
      this.timeout = setTimeout(() => {
        this.textClipBoard = "Copiar O.S";
      }, 6000);
      //alert('Ordem de serviço copiada: ' + e.text)
    },
    onError: function(e) {
      this.textClipBoard = "Erro ao copiar O.S";
      this.timeout = setTimeout(() => {
        this.textClipBoard = "Copiar O.S";
      }, 6000);
    },

    chamarPacienteDialog() {
      var paciente = this.listaPacientesDisponiveis[this.radioProximoPaciente];
      this.fazerChamadaDialog(paciente);
	},
	
	proximoLocalPaciente(){
		 // se n encontrou nos idLocais do primeiro 
       if(this.idLocalMedico.indexOf(this.localEscolhido.idLocal) == -1){
		 var consultaAux = this.consultas[0]
		 this.consultas.forEach(element => {
			 if(element.filaExame < consultaAux.filaExame){
              consultaAux = element
		   }
		 });
		 this.mensagemProximoLocalDialog = consultaAux.nomeLocal.split(',').join(' ou '); 
		 this.dialogProximoAtendimento = true 
	   }
	   // se encontrou nos idLocais do primeiro exame
	   else{
		 this.mensagemProximoLocalDialog = this.localEscolhido.nomeLocal
		 this.dialogProximoAtendimento = true 
	   }
	},

    montarMensagemProximoLocal() {
      this.mensagemProximoLocalMontada = "";      
      if (this.mensagemProximoLocal.length > 0) {
        //return 'mensagem has length'
        if (this.mensagemProximoLocal.length == 1) {
          this.mensagemProximoLocalMontada = this.mensagemProximoLocal[0];
        } else {
          this.mensagemProximoLocalMontada = this.mensagemProximoLocal.join(
            " ou "
          );
        }
      }
    },

    voltar() {
      (this.ficha = {
        codigo: "",
        nomeEspecialidade: "",
        idAtendimento: "",
        idLocal: "",
        nomePaciente: "",
        status: ""
	  }),
	  this.show = false;
      (this.isEspera = false);
      this.fezChamada = false; // added by me
      this.emPacientePendente = false; // added by me
    },

    fecharDialogConsultasPaciente() {
      this.dialoConsultasPaciente = false;
      this.listaConsultasPaciente = [];
    },

    refreshToken() {
      console.log("1111 socket connecteddddd", this.socket.connected);
      console.log("funcao refresh token");
      medicoService.medico
        .refreshToken(
          getToken(),
          this.localEscolhido.idLocal,
          this.unidadeSelecionada.idUnidade
        )
        .then(rsp => {
          console.log(rsp);
          if (rsp.status == 200) {
            console.log("antes", rsp.data.token);
            setToken(rsp.data.token);
            this.emRefreshToken = true;
            console.log("estado do socket antes");
            this.socketAux = io.connect(socketService.SOCKET_URL, {
              query: {
                token: getToken()
              }
            });

            console.log("estado do socket dps");
            let connected = new Promise(
              function(resolve, reject) {
                this.interval = setInterval(() => {
                  if (this.socketAux.connected) {
                    var self = this;
                    if (self.socket) {
                      self.socket.destroy();
                      delete self.socket;
                      self.socket = null;
                    }
                    this.socket = this.socketAux;
                    console.log("socket connecteddddd", this.socket.connected);
                    resolve("connected");
                  }
              }, 100);
              }.bind(this)
            );

            connected.then(
              function(response) {
                if (response == "connected") {
                  clearInterval(this.interval);
                  console.log("promisse", response);
                  this.chamarSocket();
                  this.adicionarServicos(true);
                  this.organizarExames(); //adicionou agora..
                }
              }.bind(this)
            );
            console.log("promisse", connected);
            //quando connectado chama esses
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    getColor(data) {
      var color = "greyLight";
      if (data != null && data !== "" && !this.fezChamada) {
        color = "greyPrimary";
      }
      if (this.fezChamada && !this.isAtendimento) {
        color = "aBlue";
      }
      if (this.isAtendimento) {
        color = "primary";
      }
      return color;
    },

    timeDurationToString(duration) {
      return duration > 9 ? duration : "0" + duration;
    },

    chamarModalConexao() {
      console.log("em chamarModalConexao..");

      if (this.mensagemNotificacaoSocket == "aguardando conexao") {
        console.log("em if aguardando conex");
        this.aguardandoConexao = true;
      }
      if (this.mensagemNotificacaoSocket == "conectado") {
        this.aguardandoConexao = false;
      } else if (this.mensagemNotificacaoSocket == "desconectado") {
        this.aguardandoConexao = true;
      }
    },

    retornarLocais() {
      console.log("retornar servicos do medico..");
      medicoService.medico
        .retornarLocais()
        .then(rsp => {
          console.log("rsp locais");
          this.listaLocais = rsp.data;
          //this.localEscolhido = localEscolhido[0];
          console.log(this.listaLocais);
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    retornarServicosDoMedico() {
      console.log("em retServMedic");
      medicoService.medico
        .retornarServicosDoMedico()
        .then(rsp => {
          console.log("rsp retServMedic", rsp.data);
          //this.listaServicos = rsp.data; comnentei isso
          this.listaServicosDoMedico = rsp.data; // adicinei isso
          this.agruparUnidade(this.listaServicosDoMedico);
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    agruparUnidade(data) {
      if (data.length) {
        var unidadesAgrupadas = this.groupBy(data, "idUnidade");
        unidadesAgrupadas.forEach(element => {
          var unidade = {
            nomeUnidade: element[0].nomeUnidade,
            idUnidade: element[0].idUnidade
          };
          this.listaUnidades.push(unidade);
        });
      }
    },

    agruparLocaisPorUnidade(unidade) {
      this.listaLocais = [];
      this.localEscolhido = "";
      this.listaServicos = [];
      this.listaServicosSelecionados = ""; // added
      if (unidade != undefined) {
        console.log("agrup idUnidade", unidade);
        var listaServicos = JSON.parse(JSON.stringify(this.listaServicosDoMedico));
        var retorno = listaServicos.filter(
          element => element.idUnidade == unidade.idUnidade
        );
        retorno.forEach(elementRetorno => {
          elementRetorno.nomeLocais = elementRetorno.nomeLocais.split(",");
          elementRetorno.idLocais.split(",").forEach((element, index) => {
            var local = {
              idLocal: element,
              nomeLocal: elementRetorno.nomeLocais[index],
              idUnidade: elementRetorno.idUnidade
            };
			this.listaLocais.findIndex(element => element.idLocal == local.idLocal)
			 == -1 ? this.listaLocais.push(local) : "";
           });
        });
      } else {
        console.log("undefined");
        this.listaLocais = [];
      }
    },

    agruparServicosPorLocal(local) {
      this.listaServicos = [];
      this.listaServicosSelecionados = "";
      if (local != undefined) {
        console.log("local", local);
        var listaServicos = JSON.parse(
          JSON.stringify(this.listaServicosDoMedico)
        );
        var retorno = listaServicos.filter(
          element => element.idUnidade == local.idUnidade
        );
        console.log("retorno servicos", retorno);

        retorno.forEach(elementRetorno => {
          elementRetorno.idLocais = elementRetorno.idLocais.split(",");
          elementRetorno.exames = elementRetorno.exames.split(",");
          var servico = {
            idServico: elementRetorno.idServico,
            nomeEspecialidade: elementRetorno.nomeEspecialidade,
            exames: elementRetorno.exames
          };
          elementRetorno.idLocais.find(element => element == local.idLocal) ==
          undefined
            ? ""
            : this.listaServicos.push(servico);
        });
      } else {
        console.log("undefined");
        this.listaServicos = [];
      }
    },

    validateField() {
      this.$refs.form.validate();
    },

    adicionarServicosParaAtendimento() {
      console.log("em adicionar servicos ..");

      if (this.$refs.form.validate()) {

       this.listaServicosEscolhidos = JSON.parse(JSON.stringify(this.listaServicosSelecionados)); // add 20/03
       this.$store.dispatch("ServicosEscolhidos", this.listaServicosEscolhidos);

        this.listaServicos.forEach(element => {
          element.disponivel = false;
        });

        this.listaServicos.forEach(item => {
          for (let index = 0;index < this.listaServicosSelecionados.length;index++) {
            if (this.listaServicosSelecionados[index].idServico == item.idServico) {
              item.disponivel = true;
            }
          }
        });

        this.listaServicosDisponibilidade[0] = this.listaServicos[0];
        this.listaServicos.forEach(item => {
          this.vertificarServicoExiste(item);
        });

        this.nomeConsultorioCompleto = this.descricaoLocal.descricao + this.nomeConsultorio;
        this.refreshToken();
      }
      //this.organizarExames();
    },

    vertificarServicoExiste(item) {
      var x = 0;
      this.listaServicosDisponibilidade.forEach(item2 => {
        if (item2.idServico == item.idServico) {
          console.log("TRUEEEEEEEEEE");
          x = 1;
          return true;
        }
      });
      if (x == 0) {
        console.log("FALSEEEEEEEEEEEE");
        this.listaServicosDisponibilidade.push(item);
      }
      return false;
    },

    organizarExames() {
      // metodo para adicionar os exames a cadas servico da lista de servicos
      console.log("em organizar..");

      //this.listaServicosEscolhidos = this.listaServicosSelecionados; //add depois do erro !!
     // this.listaServicosEscolhidos = JSON.parse(JSON.stringify(this.listaServicosSelecionados));
     // this.$store.dispatch("ServicosEscolhidos", this.listaServicosEscolhidos);

      var listaServicosSelecionadosAux = [];
      this.listaServicosSelecionados.forEach(
        function(item, index) {
          listaServicosSelecionadosAux[item.idServico] = item;
        }.bind(this)
      );

      listaServicosSelecionadosAux.forEach(element => {
        element.examesIndexados = [];
        element.exames.forEach(exame => {
          element.examesIndexados[exame] = exame;
        });
      });

      this.listaServicosSelecionados = listaServicosSelecionadosAux;
      console.log("indexada testeeeee", listaServicosSelecionadosAux);

      var nomeConsultorioServicos = {
        nomeConsultorio: this.descricaoLocal.descricao + this.nomeConsultorio,
        servicos: this.listaServicosSelecionados
      };

      this.nomeConsultorioCompleto =
      this.descricaoLocal.descricao + this.nomeConsultorio;

      this.$store.dispatch("NomeConsultorioServicos", nomeConsultorioServicos);
      this.$store.dispatch("LocalEscolhido", this.localEscolhido);
      //this.nomeConsultorio = this.user.nomeConsultorioServicos.nomeConsultorio; // removed here
      this.$store.dispatch(
        "ServicosDisponibilidade",
        this.listaServicosDisponibilidade
      );
    },

    adicionarServicos(primeiroAcesso) {
      console.log("em adiconar servicos...");
      console.log(
        "lista serv disponibilidade",
        this.listaServicosDisponibilidade
      );

      medicoService.medico
        .adicionarServicos(
          this.listaServicosDisponibilidade,
          this.user.nome,
          primeiroAcesso,
          this.localEscolhido.nomeLocal,
          this.nomeConsultorioCompleto,
          this.user.tecnico
        )
        .then(rsp => {
          console.log("servicos adicionados...");
          if (rsp.data == true) {
            this.mostrarTelaPrincipal = true;
            this.nomeConsultorio = this.user.nomeConsultorioServicos.nomeConsultorio; // added here
            this.retornarPacientesDisponiveis(primeiroAcesso);
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    limparIntervalos() {
      console.log("limpar intervalos");
      this.intervalos.forEach(clearInterval);
    },

    atendimentoEmEspera() {
      medicoService.medico
        .atendimentoEmEspera(this.ficha.idAtendimento)
        .then(rsp => {
          console.log("rsp atendimento espera", rsp.data);
          if (rsp.data == true) {
            var copiaFicha = JSON.parse(JSON.stringify(this.ficha));
            this.listaPacientesEspera.push(copiaFicha);
            this.seconds = 0 * 60;
			(this.tempoAtendimento = "00:00:00"), this.limparIntervalos();
			this.textCronometroRegrassivo = "[00:00]";
			this.show = false;
            this.isEspera = false;
            this.fezChamada = false;
            this.isAtendimento = false;
            this.nChamada = 0;
            (this.isPendentes = false), (this.iniciouAtendimento = false);
            (this.ficha.senha = ""),
              (this.ficha.codigo = ""),
              (this.ficha.nomeEspecialidade = ""),
              (this.ficha.nomePaciente = ""),
              (this.ficha.idAtendimento = ""),
              (this.ficha.idLocal = "");
            //this.mostrarTelaPrincipal = true
          }
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    retornarConsultasPaciente() {
      medicoService.medico
        .retornarConsultasPaciente(this.ficha.idAtendimento)
        .then(rsp => {
		  console.log("rsp retornarConsultasPaciente:",JSON.parse(JSON.stringify(rsp.data)));
          this.listaConsultasPaciente = rsp.data;
          this.listaConsultasPaciente.forEach(element => {
            if (element.status == 1) {
              element.primeiroStatus = true;
              element.status = true;
             } else if (element.status == 0) {
              element.primeiroStatus = false;
              element.status = false;
            }
            if (!this.vertificarExameMedico(element.idServico, element.idExame)) {
              element.status = 0;
              element.tile = 1;
            }
          });
          this.listaConsultasPacienteAgrupada = this.groupBy(
            this.listaConsultasPaciente,
            "idUnidade"
          );
          this.dialoConsultasPaciente = true;
          
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    encerrarAtendimento() {
      console.log("em encerrar atendimento...");
      var dataChegada = this.listaConsultasPaciente[0].dataChegada;
      var listaConsultasFiltrada = this.listaConsultasPaciente.filter(exame => {
        return exame.status == true;
      });
      console.log("filtrada...", listaConsultasFiltrada);
      //return;
      if (listaConsultasFiltrada.length == 0) {
        this.dialogNaoExecutouExame = true;
        return;
      }
      medicoService.medico
        .encerrarAtendimento(
          this.ficha.idAtendimento,
          listaConsultasFiltrada,
          dataChegada,
          this.nomeConsultorioCompleto,
          !this.user.tecnico
        )
        .then(rsp => {
          console.log("rsp encerrarAtendimento:", rsp.data);
          this.dialoConsultasPaciente = false;
          if (rsp.data == true) {
            this.possuiProximoAtendimento = false;
            this.mensagemCabecalhoProximoAtendimento =
              "O Paciente não possui próximos atendimentos";
            this.mensagemProximoServico =
              "O Paciente não possui próximos atendimentos";
            this.mensagemProximoLocal = "Não há";
            this.mensagemProximoExame = "Não há";
          } else {
			this.consultas = JSON.parse(JSON.stringify(rsp.data))	
            
            this.possuiProximoAtendimento = true;
            this.mensagemCabecalhoProximoAtendimento =
			  "Por favor, Solicite que o Paciente dirija-se ao próximo atendimento.";
			this.mensagemIdProximaUnidade = rsp.data[0].idUnidade;
            this.mensagemProximoServico = rsp.data[0].nomeEspecialidade;
            // vem um servico com mais de um local...
            this.mensagemProximoExame = rsp.data[0].nomeExame;
            this.mensagemProximoLocal = rsp.data[0].nomeLocal;

            this.mensagemProximoLocal = rsp.data[0].nomeLocal.split(","); // add recet
            this.idLocalMedico = rsp.data[0].idLocalMedico.split(",").map(x=>+x); //add recent
			this.mensagemProximaUnidade = rsp.data[0].nomeUnidade;
			this.proximoLocalPaciente()
            //this.montarMensagemProximoLocal();
          }
          this.seconds = 0 * 60;
		  (this.tempoAtendimento = "00:00:00"), this.limparIntervalos();
		  this.textCronometroRegrassivo = "[00:00]";
          this.show = false;
          this.dialogProximoAtendimento = true;
          this.fezChamada = false;
          this.isEspera = false;
          this.isAtendimento = false;
          this.nChamada = 0;
          (this.isPendentes = false), (this.iniciouAtendimento = false);

          (this.ficha.senha = ""),
            (this.ficha.codigo = ""),
            (this.ficha.nomeEspecialidade = ""),
            (this.ficha.nomePaciente = ""),
            (this.ficha.idAtendimento = ""),
            (this.ficha.idLocal = "");
          console.log(rsp);
          //this.retornarAtendimentos(); preecher novamente a lista
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
	},

    toggle(index) {
      const i = this.selected.indexOf(index);
      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        this.selected.push(index);
      }
	},

    filtrarAtendimentosMedico(atendimentos){
        var atendimentosAux = atendimentos.filter((atendimento)=>{
             if (atendimento.idMedico == null || atendimento.idMedico == this.user.id) {
                if (this.listaServicosSelecionados[atendimento.idServico] != null) {
                     if (this.listaServicosSelecionados[atendimento.idServico]
                        .examesIndexados[atendimento.idExame] != null){
						   console.log('verificarAtendimentos true!!');						
                           return true
					   }				   
				}								
		   } 
		})
		return atendimentosAux
	},


	verificarAtendimentos(atendimentos){ // verifica ser medico atende um dos atendimentos
	   var encontrou = false
       atendimentos.forEach(function(atendimento, index, object){
		   console.log('atendimento',atendimento);		   
		   if (atendimento.idMedico == null || atendimento.idMedico == this.user.id) {
                if (this.listaServicosSelecionados[atendimento.idServico] != null) {
                     if (this.listaServicosSelecionados[atendimento.idServico]
                        .examesIndexados[atendimento.idExame] != null){
						   console.log('verificarAtendimentos true!!');						
                           encontrou = true
					   }				   
				}								
		   }
		   
	   }.bind(this));
	   console.log('jaqueeeeeeee atendimentos....',atendimentos);	   
	  if(encontrou){
         return true
      }
       else{
         return false
       }
	},



    chamarSocket() {
      this.socket.on(
        "atendido",
        function(mensagem) {
		  console.log("skt atendido", JSON.parse(JSON.stringify(mensagem)));		  
		  var atendimentosFiltrados = this.filtrarAtendimentosMedico(mensagem)
            if(atendimentosFiltrados.length){

				var atendimento = this.formatarAtendimentosTabela(atendimentosFiltrados)
				if (atendimento.atendimentoApoio == 1) {
				   var indexFinded = this.listaPacientesDisponiveis.findIndex(
					  element => element.dataStatus > atendimento.dataStatus
				   );	
                console.log("indexFinded", indexFinded);
				if (indexFinded == -1) {
					this.listaPacientesDisponiveis.push(atendimento);
				} else if (indexFinded < 3) {
					this.listaPacientesDisponiveis.splice(3, 0, atendimento);
				} else {
					this.listaPacientesDisponiveis.splice(indexFinded,0,atendimento);
				}
			  }
		     else {
                var indexFinded = this.listaPacientesDisponiveis.findIndex(
                   element => element.dataStatus > atendimento.dataStatus
                );
                console.log("else indexFinded", indexFinded);
                if (indexFinded == -1) {
                   this.listaPacientesDisponiveis.push(atendimento);
                } else {
                   this.listaPacientesDisponiveis.splice(indexFinded,0,atendimento);
                }   
              }                
			}
        }.bind(this)
      );

      this.socket.on(
        "chamandoPaciente",
        function(mensagem) {
          console.log("skt chamandoPaciente..", mensagem);
          this.listaPacientesDisponiveis.forEach((element, index) => {
            if (element.idAtendimento == mensagem.idAtendimento) {
              this.listaPacientesDisponiveis.splice(index, 1); //remover
              return;
            }
          });
          this.listaPacientesPendente.forEach((element, index) => {
            if (element.idAtendimento == mensagem.idAtendimento) {
              this.listaPacientesPendente.splice(index, 1); //remover
            }
          });
        }.bind(this)
      );

      this.socket.on(
        "connect",
        function(mensagem) {
          this.mensagemNotificacaoSocket = "conectado";
          this.chamarModalConexao();
          // chamar talvez aqui
        }.bind(this)
      );

      this.socket.on("connect_error", () => {
        this.mensagemNotificacaoSocket = "aguardando conexao";
        this.chamarModalConexao();
      });

      this.socket.on(
        "disconnect",
        function() {
          this.mensagemNotificacaoSocket = "desconectado";
          this.chamarModalConexao();
        }.bind(this)
      );
    },
    //ok
    retornarPacientesDisponiveis(primeiroAcesso) {
      medicoService.medico
        .retornarPacientesDisponiveis(
          this.listaServicosEscolhidos,
          primeiroAcesso,
          this.localEscolhido.nomeLocal,
          this.user.tecnico
        )
        .then(rsp => {
          console.log(
            "rsp retornar pacientes:",
            JSON.parse(JSON.stringify(rsp.data))
          );
          if (rsp.data != false) {
            this.listaPacientes = rsp.data;
          }
          if (this.listaPacientes.length) {
            this.organizarListapacientes();
            //   this.listaPacientes.forEach(element => {
            //   if (element.status == 1) {
            //     this.listaPacientesDisponiveis.push(element);
            //   } else if (element.status == 2) {
            //     this.listaPacientesPendente.push(element);
            //   } else if (element.status == 3) {
            //     var serverDate = new Date(element.dataStatus);
            //     element.dataStatusCronometro = serverDate.getTime();
            //     this.listaPacientesEspera.push(element);
            //   }
            // });
          }
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
	},

	formatarAtendimentosTabela(atendimento){
		var atendimentoAux = atendimento[0];
		this.$set(atendimentoAux,'atendimentos', [])
		for (let index = 1; index < atendimento.length; index++) {
			const element = atendimento[index];
			atendimentoAux.atendimentos.push(element)		
		}
		return atendimentoAux
	},

	formatarEnvioAtendimento(atendimento){
	   var atendimentoAux = []
	   atendimentoAux.push(JSON.parse(JSON.stringify(atendimento)));
	   atendimento.atendimentos.forEach(element => {
		 atendimentoAux.push(element);  
	   });
	   delete atendimentoAux[0].atendimentos
	   return atendimentoAux       
     },
	
	organizarListapacientes(){
       
	   var listaPacientesAux = []
	   var elementPrincipal = JSON.parse(JSON.stringify(this.listaPacientes[0]))
	   this.$set(elementPrincipal,'atendimentos', [])
	   listaPacientesAux.push(elementPrincipal)
	   for (let index = 1; index < this.listaPacientes.length; index++) {
		   const element = this.listaPacientes[index];		   
		   if(element.idAtendimento != elementPrincipal.idAtendimento){			   			   
			   elementPrincipal = this.listaPacientes[index]
			   this.$set(elementPrincipal,'atendimentos', [])
			   listaPacientesAux.push(elementPrincipal)
		   }
		   else{			  
			  elementPrincipal.atendimentos.push(element)
		   }
	   }
	   this.listaPacientes = listaPacientesAux	   
	   this.adicionarPacientesAFilas();
	
    },

    adicionarPacientesAFilas() {
      this.listaPacientes.forEach(element => {
        if (element.status == 1) {
          this.listaPacientesDisponiveis.push(element);
        } else if (element.status == 2) {
          this.listaPacientesPendente.push(element);
        } else if (element.status == 3) {
          var serverDate = new Date(element.dataStatus);
          element.dataStatusCronometro = serverDate.getTime();
          this.listaPacientesEspera.push(element);
        }
      });
    },

    addFicha(item) {
		
      if (item.status == 2) {
        console.log("pendenteeee");
        this.fezChamada = true;
        this.emPacientePendente = true;
      } else {
        this.fezChamada = false;
      }
      console.log("item", item);
      this.iniciouAtendimento = false;
      this.ficha.codigo = item.codigo;
      this.ficha.idAtendimento = item.idAtendimento;
      this.ficha.idLocal = item.idLocal;
      this.ficha.idLocalMedico = item.idLocalMedico;
      this.ficha.idServico = item.idServico;
      this.ficha.nomePaciente = item.nomePaciente;
      this.ficha.nomeEspecialidade = item.nomeEspecialidade;
      this.ficha.status = item.status;
      this.ficha.dataStatus = item.dataStatus;
      this.ficha.idExame = item.idExame;
      this.ficha.prioridade = item.prioridade;
      this.ficha.idConsulta = item.idConsulta;
      this.ficha.nomeExame = item.nomeExame;
	  this.ficha.idOrdemServico = item.idOrdemServico;
	  this.ficha.atendimentos = item.atendimentos
      console.log("em add item ficha:");
	  console.log("ficha", this.ficha);
	  //console.log('formatar',this.formatarEnvioAtendimento(this.ficha));
    },

    addFichaEspera(item) {
      console.log("item espera", item);
      this.isEspera = true;
      this.emPacienteEspera = true;
      this.fezChamada = false;
      this.iniciouAtendimento = false;
      this.ficha.codigo = item.codigo;
      this.ficha.idAtendimento = item.idAtendimento;
      this.ficha.idLocal = item.idLocal;
      this.ficha.idServico = item.idServico;
      this.ficha.nomeExame = item.nomeExame;
      this.ficha.nomePaciente = item.nomePaciente;
      this.ficha.nomeEspecialidade = item.nomeEspecialidade;
      this.ficha.status = item.status;
      this.ficha.dataStatus = item.dataStatus;
      this.ficha.dataStatusCronometro = item.dataStatusCronometro; // added b me
      this.ficha.idExame = item.idExame;
      this.ficha.prioridade = item.prioridade;
      this.ficha.idConsulta = item.idConsulta;
	  this.ficha.idOrdemServico = item.idOrdemServico;
	  this.ficha.atendimentos = item.atendimentos	  
    },

    fazerChamada() {
      //ok
      console.log("em fazer chamada medico...");
      this.desabilitaBotaoChamar = true;
      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.desabilitaBotaoChamar = false;
      }, 10000);

      medicoService.medico
        .fazerChamada(
          this.ficha.idAtendimento,
          this.ficha.codigo,
          this.nomeConsultorio,
          this.ficha.idConsulta,
          this.user.nome,
          this.ficha.nomePaciente,
          this.ficha.prioridade,
          this.ficha.idLocalMedico,
          this.localEscolhido.nomeLocal,
          this.user.tecnico
        )
        .then(rsp => {
          console.log("rsp de fazer chamada:");
          console.log(rsp);
          if (rsp.data == true) {
            this.listaPacientesPendente.forEach((element, index) => {
              if (element.idAtendimento == this.ficha.idAtendimento) {
                this.listaPacientesPendente.splice(index, 1);
              }
            });

            this.habilitarBotaoCronometro == true ||
            this.intervalContagemRegressiva ? "" : this.chamarCronometroRegressivo();
            this.fezChamada = true;
            this.nChamada = this.nChamada + 1;

            this.emPacientePendente = false;
          }
          if (rsp.data == false) {
            this.dialogChamadaJaFeita = true;
          }
          //this.retornarAtendimentos(); preecher novamente a lista
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    converterHorarioStatus(status) {
      var convertido = new Date(status).getTime();
      return convertido;
    },

    chamarModalNaoCompareceu() {
      this.dialogNaoCompareceu = true;
    },

    reiniciarAtendimento() {
      this.iniciouAtendimento = true;
      this.fezChamada = true;
      this.isAtendimento = true;

      for (let index = 0; index < this.listaPacientesEspera.length; index++) {
        if (this.listaPacientesEspera[index].idAtendimento == this.ficha.idAtendimento) {
          this.listaPacientesEspera.splice(index, 1);
        }
      }
      var dataFicha = this.ficha.dataStatusCronometro;
      var dataAgora = new Date().getTime();
      var segundos = new Date(dataAgora - dataFicha) / 1000;
      this.seconds = Math.trunc(segundos);
      this.chamarCronometro();
    },

    iniciarAtendimento() {
      console.log("em chamarCodigo...");
      this.isAtendimento = true;
      this.emPacientePendente = false;
      medicoService.medico
        .iniciarAtendimento(
          this.ficha.idAtendimento,
          this.ficha.codigo,
          this.ficha.idConsulta
        )
        .then(rsp => {
          console.log("rsp de iniciar Atend:");
          console.log(rsp);
          if (rsp.status == 200) {
            for (let index = 0; index < this.listaPacientesPendente.length; index++) {
              if (this.listaPacientesPendente[index].idAtendimento == this.ficha.idAtendimento) {
                this.listaPacientesPendente.splice(index, 1);
              }
            }
            this.habilitarBotaoCronometro = false;
            clearInterval(this.intervalContagemRegressiva);
            this.intervalContagemRegressiva = "";
            this.iniciouAtendimento = true;
            this.ficha.dataStatusCronometro = new Date().getTime();
            this.chamarCronometro();
          }
          //this.retornarAtendimentos(); preecher novamente a lista
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    chamadaNaoAtendida() {
      //ok
      console.log("em chamadaNaoAtendida...");

      medicoService.medico
        .chamadaNaoAtendida(
          this.ficha.idAtendimento,
          this.ficha.idServico,
          this.ficha.codigo,
          this.ficha.nomeEspecialidade,
          this.ficha.nomePaciente,
          this.ficha.idExame,
          this.ficha.idLocalMedico,
          this.ficha.nomeExame,
          this.ficha.idOrdemServico
        )
        .then(rsp => {
          console.log("rsp de chamada nao atedida:");
          console.log(rsp);
          if (rsp.data == true) {
            this.nChamada = 0;
			this.habilitarBotaoCronometro = false;
			this.textCronometroRegrassivo = "[00:00]";
			this.show = false;
            clearInterval(this.intervalContagemRegressiva);
            this.intervalContagemRegressiva = "";
            this.isPendentes = false;
            this.dialogNaoCompareceu = false;
            this.fezChamada = false;
            this.ficha.nomeEspecialidade = "";
            this.ficha.nomePaciente = "";
            this.ficha.codigo = ""
            for (let index = 0; index < this.listaPacientes.length; index++) {
              if (this.listaPacientes[index].codigo == this.ficha.codigo) {
                  this.listaPacientes.splice(index, 1);
              }
            }
            for ( let index = 0; index < this.listaPacientesPendente.length;index++ ) {
              if ( this.listaPacientesPendente[index].codigo == this.ficha.codigo ) {
                   this.listaPacientesPendente.splice(index, 1);
              }
            }
          }

          //this.retornarAtendimentos(); preecher novamente a lista
        })
        .catch(err => {
          // handle your error here
          console.log(err);
        });
    },

    setarGuiche() {
      console.log("em setar guiche...");
      this.guiche = this.guicheSelecionado;
    },

    dialogLogout() {
      console.log("dialog logout");
      if (this.listaPacientesEspera.length > 0 || this.listaPacientesPendente.length > 0 ) {
        this.dialogComformarSair = true;
      } else {
        this.logout();
      }
    },

    logout() {
      console.log("em logout..");
      //this.$router.push("/login");
      this.$store
        .dispatch("FedLogOut")
        .then(rsp => {
          this.limparIntervalos();
          this.socket ? this.socket.close() : "";
          this.$router.push("/login");
          if (r) {
          }
        })
        .catch(error => {});
    },

    groupBy(collection, property) {
      var i = 0,
        val,
        index,
        values = [],
        result = [];
      for (; i < collection.length; i++) {
        val = collection[i][property];
        index = values.indexOf(val);
        if (index > -1) result[index].push(collection[i]);
        else {
          values.push(val);
          result.push([collection[i]]);
        }
      }
      return result;
    },

    nomeFormatado(str) {
      var arr = str.split(" ");
      if (arr[1] != null) {
        var preposicao = arr[1].toLowerCase();
        if (preposicao == "de" || preposicao == "da" || preposicao == "das" || preposicao == "do" ||
          preposicao == "dos"
        ) {
          preposicao = true;
        } else {
          preposicao = false;
        }
      }
      return arr.slice(0, preposicao ? 3 : 2).join(" ");
    }
  },

  mounted() {    

    this.user = this.$store.getters.usuario;
    console.log("mounted user", this.user);

    if (this.user.tipo != 8) {
      this.$router.push("/login");
      return;
    }

    if (this.user.nomeConsultorioServicos) {
      this.socket = io.connect(socketService.SOCKET_URL, {
        query: {
          token: getToken()
        }
	  });
	  
      this.chamarSocket();
      this.listaServicosDisponibilidade = this.user.ServicosDisponibilidade;
      this.listaServicosSelecionados = this.user.nomeConsultorioServicos.servicos;
      this.listaServicosEscolhidos = this.user.servicosEscolhidos;
      this.localEscolhido = this.user.localEscolhido;
      this.nomeConsultorio = this.user.nomeConsultorioServicos.nomeConsultorio;
      this.nomeConsultorioCompleto = this.user.nomeConsultorioServicos.nomeConsultorio;
      this.adicionarServicos(false);
      this.mostrarTelaPrincipal = true;
    } else {
      this.nomeConsultorio =
        this.user.nomeConsultorio == null || "Laboratório"
          ? ""
          : this.user.nomeConsultorio;
      this.retornarServicosDoMedico();
    }
  },

  beforeDestroy: function() {
    console.log("before destruido");
    this.limparIntervalos();
    //this.offline();
  },

  created() {
    this.user = this.$store.getters.usuario;
  },
  watch: {
    model: "validateField",
    nomeConsultorio: "validateField",
    rules: "validateField",
    descricaoLocal: "validateField"
  },

  computed: {
    verificarSocket() {
      // n usando !
    },

    rules() {
      const rules = [];
      if (this.descricaoLocal) {
        if (this.descricaoLocal.descricao === "Consultório ") {
          const rule = v =>
            (v && v.length <= 5) || "Mínimo 1 e máximo 5 caracteres";
          rules.push(rule);
        }
        const rule = v =>
          v.length <= 5 || v.length == 0 || "Mínimo 0 e máximo 5 caracteres";
        rules.push(rule);
      }
      return rules;
	},
	    
  }
};
</script>

<style scoped>
#mybutton2 {
  position: fixed;
  bottom: 60px;
  right: 180px;
}
.tile {
  margin: 0px;
  border-radius: 3px;
  background: rgb(167, 160, 160);
}

.rounded-card {
  border-radius: 50px;
}

.mensagemInicial {
  font-family: "Merriweather", serif;
  font-size: 21px;
}
</style>
